import { Tc, PagingResultsViewModel } from "../../../core/_infrastructure/types/common";


export class NumeroSeguridadItemResultsViewModel extends PagingResultsViewModel {

    public ResultList: NumeroSeguridadViewModel[];
}
export class NumeroSeguridadViewModel {

    constructor() {

    }

    public Id: number;
    public IdSolicitudEx: number;
    public Codigo: string = ''; //nº solicitud
    public CodigoCopia: string = '';
    public IdTipoSolicitud: number | null = null;
    public NumeroCertificado: string = '';
    public IdPagina: number | null = null;
    public NumSeguridad: string = '';    
    
}







